import moment from "moment"
import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"
import { Card, CardBody, Col, Row } from "reactstrap"
import "../../../../node_modules/bootstrap/dist/css/bootstrap.min.css"
import { useDispatch, useSelector } from "react-redux"
import FilterLayout from "./FilterLayout"
import { getallprojectslist, workScreen } from "store/workreport/action"
import Projectaccordian from "./Projectaccordian"

function VerifyworkReport() {
  //meta title
  document.title =
    "Verify Work Hours | TenderSoftware - Flexi TracBoard"

  const [startDate, setStartDate] = useState(new Date())
  const [endDate, setEndDate] = useState(new Date())
  const fromDate = moment(new Date(startDate)).format("YYYY-MM-DD")
  const [screenResponse, setscreenResponse] = useState()
  const dispatch = useDispatch()
  const userid = JSON.parse(localStorage.getItem("authUser") || "{}")?.data?.id

  const project = {
    categoryuserid: userid,
    date: fromDate,
  }

  useEffect(() => {
    const authUser = localStorage.getItem('authUser');
    if(authUser){
      const authUserJS = JSON.parse(authUser);
      dispatch(getallprojectslist({...project, categoryId: authUserJS?.data?.categoryid }))
    }else{      
      dispatch(getallprojectslist(project))
    }
  }, [])

  const { reports, screens, reportsTimes } = useSelector(state => ({
    reports: state?.workreport?.projectListsSuccess?.projectList,
    reportsTimes: state?.workreport?.projectListsSuccess,
    screens: state?.workreport?.workscreenSuccessList?.projectList,
  }))

  useEffect(() => {
    setscreenResponse(screens)
  }, [screens])

  const loadTeamScreen = () => {
    const authUser = localStorage.getItem('authUser');
    const authUserJS = JSON.parse(authUser);
    dispatch(getallprojectslist({...project, categoryId: authUserJS?.data?.categoryid }))
  }

  const onHandleFilterBtnClicked = () => {
    loadTeamScreen()
  }

  const handleSubmit = e => {
    e.preventDefault()
    onHandleFilterBtnClicked()
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Card>
            <CardBody>
              <FilterLayout
                setStartDate={setStartDate}
                startDate={startDate}
                setEndDate={setEndDate}
                endDate={endDate}
                onHandleFilterBtnClicked={onHandleFilterBtnClicked}
                handleSubmit={handleSubmit}
              />
              <Row>
                <Col xs="12">
                  <Projectaccordian reports={reports || []} />
                </Col>
              </Row>
            </CardBody>
          </Card>
        </div>
      </div>
    </React.Fragment>
  )
}

VerifyworkReport.propTypes = {
  preGlobalFilteredRows: PropTypes.any,
}

export default VerifyworkReport
